// Canonical variant-condition domain (U2 · Identity Core).
//
// These nine values ARE the `variants.condition` CHECK constraint minted in
// migration 20260706000001 (U2 S1). The UI selects a condition ONLY from this
// list — there is NO free-text condition anywhere in the product/variant surface.
// Order is best → worst (matches the constraint's declared array order), so it
// doubles as the display order for the condition picker.
const CONDITION_VALUES = [
  'new',
  'open_box',
  'manufacturer_refurbished',
  'seller_refurbished',
  'used_like_new',
  'used_very_good',
  'used_good',
  'used_acceptable',
  'for_parts',
] as const;

type ConditionValue = (typeof CONDITION_VALUES)[number];

// Human-readable labels for the picker + variant rows. Keys are exhaustive over
// CONDITION_VALUES (compile-time enforced by the Record<ConditionValue, …> type).
const CONDITION_LABELS: Record<ConditionValue, string> = {
  new: 'New',
  open_box: 'Open Box',
  manufacturer_refurbished: 'Manufacturer Refurbished',
  seller_refurbished: 'Seller Refurbished',
  used_like_new: 'Used — Like New',
  used_very_good: 'Used — Very Good',
  used_good: 'Used — Good',
  used_acceptable: 'Used — Acceptable',
  for_parts: 'For Parts / Not Working',
};

/** Label for a stored condition string; falls back to the raw value if unknown. */
export function conditionLabel(condition: string): string {
  return (CONDITION_LABELS as Record<string, string>)[condition] ?? condition;
}

/** Options for an ArbiSelect condition picker, in canonical best→worst order. */
export const CONDITION_OPTIONS = CONDITION_VALUES.map((value) => ({
  value,
  label: CONDITION_LABELS[value],
}));
